<template>
  <div @click="goToDetail()">
    <vs-dropdown>
      <!-- {{ params.value.name }} -->
      <img src="./../../../../assets/metro-info.svg" class="pr-2" />
      <vs-dropdown-menu>
        <vs-dropdown-item>
          <div class="w-max test">
            <div class="grid grid-cols-4 gap-x-3 header-text">
              <div class="col-span-1"><p>เดือน/ปี</p></div>
              <div class="col-span-3"><p>ชื่อ</p></div>
            </div>
            <div
              v-for="(datum, index) in params.data.iconInfo"
              :key="index"
              class="grid grid-cols-4 gap-x-3"
            >
              <div class="col-span-1">
                <p>{{ formattedDate(datum.dataInvoice) }}</p>
              </div>
              <div class="col-span-3">
                <p>{{ datum.accounting.name_th }}</p>
              </div>
            </div>
          </div>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import moment from "moment";
export default {
  mounted() {
    // console.log("params", this.params);
  },
  methods: {
    goToDetail() {
      console.log(this.params.data);
    },
    formattedDate(date) {
      return moment(date).format("MM/YYYY");
    },
  },
};
</script>

<style scoped>
p {
  color: #434f5b;
  white-space: nowrap;
}

.header-text {
  border-bottom: solid 0.5px #8d9498;
}

/* .test {
  max-height: 200px;
  overflow-y: scroll;
} */
</style>
